import type { TOC } from '@ember/component/template-only';
import PageLoading from '../components/page-loading.gts';

interface Signature {
  Args: {};
}

const SearchLoading: TOC<Signature> = <template>
  <PageLoading @title="Search" />
</template>;

export default SearchLoading;
